// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  newServiceUrl:'https://stratgist.com/MasterProjectByte/MasterProjectByte/',
  hostUrl: 'https://stratgist.com/MasterProjectByte',
  imagePath: 'https://stratgist.com/MasterProjectByte/ModuleImage',
  summaryPath: 'https://stratgist.com/MasterProjectByte/ModuleSummary',
  happCoachUrl: 'http://www.happcoach.com', 
  paymentUrl:"https://stratgist.com/MasterProjectBytePayment/?Paymentid=",
  footer40:false
};



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/environments/environment.ts